module.exports = __webpack_public_path__ + "img/japan-leukaemia-female.e8ec89ae.png";